import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from '../config/app.constant';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  url: string;
  accessToken: any;
  token_type: any;
  token: string;

  constructor(private apiService: ApiService) { }

  getauthorizationToken(): Observable<any> {
    this.url = APIs.getAuthToken;
    const paramObj = {
      client_id: "CglhiTG9uTjsQYyD",
      client_secret: "jy9qS4XJyFjFinEYwNAolrxyzat5HxN0",
      grant_type: "client_credentials",
      scope: "officernd.api.read officernd.api.write"
    };
    return this.apiService.get(this.url, paramObj).pipe(map(response => {
      return response;
    }));
  };

  getApiauthorizationToken(email, password): Observable<any> {
    this.url = APIs.getApiAuthToken;
    const paramObj = {
      email: email,
      Password: password
    };
    return this.apiService.get(this.url, paramObj, {
      "Access-Control-Allow-Origin": "*"
    }).pipe(map(response => {
      // console.log(response);
      if (response.isValid) {
        localStorage.setItem('completeOjb', JSON.stringify(response.list));
        localStorage.setItem('Tokens', JSON.stringify(response.list[0].userDetail.TokenDetails))
        // localStorage.setItem(AppConstant.localStorage.token, response.list[0].token);
        return { status: response.isValid, data: response.data, isUserLocked: response.list[0].IsUserLocked };
      } else {
        return {
          status: response.isValid,
          data: response.errorMsg,
          isUserLocked: response.list ? response.list.userDetail.TokenDetails[0].IsUserLocked : false //Need to check
        };
      }

    }));
  };

  getTenantId(): Observable<any> {
    this.url = APIs.getUserDetail;
    const paramObj = {
    };
    return //this.apiService.get(this.url, paramObj).pipe(map(response => {
    //localStorage.setItem(AppConstant.localStorage.tenantId, response.data.t0200OrgEmployees[0]?.tenantId);
    //}));
  };

  getAdminToken(email): Observable<any> {
    this.url = APIs.getAdminDetails;
    const paramObj = {
      Email: email
    };
    return this.apiService.get(this.url, paramObj).pipe(map(response => {
      localStorage.setItem(AppConstant.localStorage.token, response.data);
      return response;
    }));
  };

  logoutToken(): Observable<boolean> {
    const paramObj = {
      token: localStorage.getItem(AppConstant.localStorage.token)
    };
    return this.apiService.post(APIs.logoutToken + "/?token=" + localStorage.getItem(AppConstant.localStorage.token), null).pipe(map(response => {
      return response.isValid;
    }));
  }

  setToken(data) {
    localStorage.setItem(AppConstant.localStorage.token, data.token);
    localStorage.setItem('userType', data.userType);
    localStorage.setItem('tenantId', data.tenantID);
    localStorage.setItem('userId', data.userId);
  }



getOverviewDetail(data){
  return this.apiService.get(APIs.getOverviewTA,data).pipe(
    map((response) => {
      return response;
    })
  );
}

}
